// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingPaginationSummary_root__he4hb","root_favorites":"ListingPaginationSummary_root_favorites__G7m_W"};